export const WEB3_RAFFLE_SUPPORTED_TOKENS = ['SQR', 'USDT'] as const;

export type Web3RaffleSupportedToken = (typeof WEB3_RAFFLE_SUPPORTED_TOKENS)[number];
